import { BASE_URL } from "./config";

const ACTIVE_GAME_KEY = "mafia_host_active_game_v1";

// Запам'ятати id поточної гри, щоб відновити її після перезавантаження сторінки.
export function saveActiveGameId(gameId) {
  localStorage.setItem(ACTIVE_GAME_KEY, gameId);
}

// Прочитати id незавершеної гри, збережений раніше (або null, якщо його немає).
export function loadActiveGameId() {
  return localStorage.getItem(ACTIVE_GAME_KEY);
}

// Забути гру (викликається при завершенні гри або якщо бекенд каже, що її більше нема).
export function clearActiveGameId() {
  localStorage.removeItem(ACTIVE_GAME_KEY);
}

async function request(path, options = {}) {
  const res = await fetch(`${BASE_URL}${path}`, {
    headers: { "Content-Type": "application/json" },
    ...options,
  });

  if (!res.ok) {
    let message = `Помилка запиту (${res.status})`;
    try {
      const body = await res.json();
      if (body?.message) message = body.message;
    } catch {
      // тіло не JSON — ігноруємо
    }
    throw new Error(message);
  }

  if (res.status === 204) return null;
  return res.json();
}

// Створити нову гру з переліком гравців та їхніми ролями.
// players: [{ name, role }]
export function createGame(players) {
  return request("/games", {
    method: "POST",
    body: JSON.stringify({ players }),
  });
}

// Отримати повний стан гри (гравці + журнал дій).
export function fetchGame(gameId) {
  return request(`/games/${gameId}`);
}

// Розділ "Історія ігор": список раніше зіграних ігор (легкі зведення, без
// повного журналу дій — це для екрана списку, деталі кожної гри довантажуються
// окремо через fetchGame(gameId), який уже повертає гравців + дії).
// params: { status, limit, offset } — усі опційні.
export function fetchGamesHistory(params = {}) {
  const query = new URLSearchParams();
  if (params.status) query.set("status", params.status);
  if (params.limit != null) query.set("limit", params.limit);
  if (params.offset != null) query.set("offset", params.offset);
  const qs = query.toString();
  return request(`/games${qs ? `?${qs}` : ""}`);
}

// Записати ігрову дію (вбивство, лікування, перевірка, голосування тощо).
// action: { type, actorId, targetId, round, phase, note }
export function postAction(gameId, action) {
  return request(`/games/${gameId}/actions`, {
    method: "POST",
    body: JSON.stringify(action),
  });
}

// Оновити стан гравця (наприклад, вигнати/позначити мертвим вручну).
export function updatePlayer(gameId, playerId, patch) {
  return request(`/games/${gameId}/players/${playerId}`, {
    method: "PATCH",
    body: JSON.stringify(patch),
  });
}

// Видалити (скасувати) запис дії з журналу. Бекенд може не підтримувати цей
// ендпоінт — виклики цієї функції обгортаються в try/catch на боці екрана
// гри, тож скасування спрацює локально, навіть якщо запит на сервер впаде.
export function deleteAction(gameId, actionId) {
  return request(`/games/${gameId}/actions/${actionId}`, { method: "DELETE" });
}

// Завершити гру на бекенді.
export function endGame(gameId) {
  return request(`/games/${gameId}`, { method: "DELETE" });
}
